import {SideTabs} from '@/sites/services/typedef'

export const viewSideTab = [
  SideTabs.END_USER_SUPPORT,
  SideTabs.BUSINESS_APPS_SUPPORT_MANAGEMENT,
  SideTabs.IT_ASSETS_SUPPORT_MANAGEMENT,
]
